import type { StorefrontProduct, StorefrontVariant } from "./types";

/** Keep canonical attribute value order; UUIDs identify variants, never their display order. */
export function orderedVariants(product: StorefrontProduct): StorefrontVariant[] {
  const attributes = product.attributes.filter((attribute) => attribute.usedForVariations);
  return product.variants.map((variant, index) => ({ variant, index })).sort((left, right) => {
    for (const attribute of attributes) {
      const name = attribute.canonicalName ?? attribute.name;
      const rank = (variant: StorefrontVariant) => {
        const index = attribute.values.indexOf(variant.optionValues[name]);
        return index < 0 ? attribute.values.length : index;
      };
      const difference = rank(left.variant) - rank(right.variant);
      if (difference) return difference;
    }
    return left.index - right.index;
  }).map(({ variant }) => variant);
}

export function productImageForSelection(product: StorefrontProduct, variantId?: string, initial: "first" | "none" = "first") {
  const shared = product.media.find((item) => !item.variantId && item.role === "image") ?? product.media.find((item) => !item.variantId && item.role === "gallery");
  const id = variantId ?? (initial === "first" ? product.variantId : undefined);
  return (id ? product.media.find((item) => item.variantId === id && item.role === "image") ?? product.media.find((item) => item.variantId === id && item.role === "gallery") : undefined)?.src
    ?? shared?.src ?? (initial === "first" ? product.imageUrl : undefined);
}

export function optionSummary(values?: Record<string, string>): string {
  return Object.entries(values ?? {}).map(([label, value]) => `${label}: ${value}`).join(" · ");
}
